(function () {
  if (customElements.get('sd-cookie-banner')) return;

  const PRIVACY_FEATURES = [{ name: 'consent-tracking-api', version: '0.1' }];

  class SDCookieBanner extends HTMLElement {
    connectedCallback() {
      this.onClick = this.handleClick.bind(this);
      this.onSectionSelect = this.handleSectionSelect.bind(this);
      this.addEventListener('click', this.onClick);

      if (this.isDesignMode()) {
        document.addEventListener('shopify:section:select', this.onSectionSelect);
        this.show();
        return;
      }

      if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;

      window.Shopify.loadFeatures(PRIVACY_FEATURES, (error) => {
        if (error || !this.isConnected) return;
        if (this.needsConsent()) this.show();
      });
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      document.removeEventListener('shopify:section:select', this.onSectionSelect);
    }

    isDesignMode() {
      return Boolean(window.Shopify && window.Shopify.designMode);
    }

    getPrivacyApi() {
      return window.Shopify ? window.Shopify.customerPrivacy : null;
    }

    needsConsent() {
      const privacy = this.getPrivacyApi();
      if (!privacy) return false;

      if (this.dataset.audience === 'region') return privacy.shouldShowBanner();

      const consent = privacy.currentVisitorConsent();
      return consent.analytics === '' && consent.marketing === '' && consent.preferences === '';
    }

    handleSectionSelect(event) {
      if (event.detail && event.detail.sectionId === this.dataset.sectionId) this.show();
    }

    handleClick(event) {
      const button = event.target.closest('[data-sd-cookies-choice]');
      if (!button) return;

      const privacy = this.getPrivacyApi();
      if (this.isDesignMode() || !privacy) {
        this.hide();
        return;
      }

      const granted = button.dataset.sdCookiesChoice === 'accept';
      this.setBusy(true);

      privacy.setTrackingConsent(
        {
          analytics: granted,
          marketing: granted,
          preferences: granted,
          sale_of_data: granted,
        },
        () => this.hide()
      );
    }

    setBusy(busy) {
      this.querySelectorAll('[data-sd-cookies-choice]').forEach((button) => {
        button.disabled = busy;
      });
    }

    show() {
      this.hidden = false;
    }

    hide() {
      this.hidden = true;
      this.setBusy(false);
    }
  }

  customElements.define('sd-cookie-banner', SDCookieBanner);
})();
